import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionLaboratoryContractState: Dtos.TrialInstitutionLaboratoryContract & IRegistrationFormState = {
    id: null,
    trialInstitutionLaboratoryId: null,
    trialInstitutionLaboratory: null,
    name: null,
    location : null,
    dateSentToSite: null,
    dateConfirmedBySite: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialInstitutionLaboratoryContractReduxFormState {
    id: IFieldState<number>,
    trialInstitutionLaboratoryId: IFieldState<number>,
    trialInstitutionLaboratory: IFieldState<Dtos.TrialInstitutionLaboratory>,
    name: IFieldState<string>,
    location : IFieldState<string>,
    dateSentToSite: IFieldState<string>,
    dateConfirmedBySite: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
